import { io } from 'socket.io-client';
import globalConfig from './config/globalConfig';

// "undefined" means the URL will be computed from the `window.location` object
const URL = globalConfig.socket.apiUrl;

export const socket = io(URL);
